export class UnitServices {

  forwardControlThermal: boolean;
  forwardControlFlow: boolean;
  integrityTestCB: boolean;
  energyConsumptionDisplay: boolean;
  steamSupplyFailure: boolean;
  condensateOutletTemperature: boolean;
  lagionellaRiskIndicator: boolean;
  gasketWearDetection: boolean;
  scalingDetection: boolean;
  energyMonitoring: boolean;

}
